Vendd.Scripts.load(function () {
    var $wrapper = $('.x-control.x-sortbyselector[data-control="sorter"]');

    if ($wrapper.length < 1) return;

    var wrapper = $wrapper.get(0),
        model = null;

    wrapper.bind = function () {
        $wrapper.each(function (i, item) {
            $('select', item).sSelect({ ddMaxHeight: '200px' });

            $('select', item).change(function (e) {
                var targetUrl = $(this).find(":selected").data('url');
                if (targetUrl) document.location = targetUrl;
            });
        });
    };

    wrapper.update = function () {
        var html = Vendd.Handlebars.parse("sortBySelector", model);
        $wrapper.html(html);
        wrapper.bind();
    };

    wrapper.bind();

    Vendd.MessageBus.subscribe(Vendd.ProductList.Messages.GetModelSuccess, $wrapper, function (envelope) {
        if (envelope.message.data.data.Products.Items.length < 1)
            return;

        model = envelope.message.data.data.SortBySelector;
        wrapper.update();
    });

});

